import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const tireOptions = t => [
  { value: 1, display: t('I will keep my tires properly inflated.') },
  { value: 0, display: t('I already keep my tires properly inflated.') },
];

const airFilterOptions = t => [
  { value: 1, display: t('I will change air filters regularly.') },
  { value: 0, display: t('I already change air filters regularly.') },
];

const MaintainMyVehicles = ({
  t,
  isMetric,
  widgetSource,
  resultTakeactionMaintainMyVehiclesDispmiles,
  resultTakeactionMaintainMyVehiclesMpg,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I currently drive a total of {{resultTakeactionMaintainMyVehiclesDispmiles}} {{distanceUnit}} per year, with an average fuel economy of {{resultTakeactionMaintainMyVehiclesMpg}} {{fuelEfficiencyUnit}}.', {
          resultTakeactionMaintainMyVehiclesDispmiles,
          distanceUnit: isMetric ? t('kilometers', { ns: 'units' }) : t('miles', { ns: 'units' }),
          resultTakeactionMaintainMyVehiclesMpg,
          fuelEfficiencyUnit: isMetric ? t('L/100km', { ns: 'units' }) : t('mpg', { ns: 'units' }),
        })}
        <InlineSelect
          options={tireOptions(t)}
          apiKey={'input_takeaction_maintain_my_vehicles_tires'}
        />
        <InlineSelect
          options={airFilterOptions(t)}
          apiKey={'input_takeaction_maintain_my_vehicles_airfilter'}
        />
      </p>
    </div>
    <div className="action-details__facts">
      {t('Taking care of your car keeps you on the road instead of at the shop. Plus, your smoothly running machine trims pounds of your carbon footprint.')}
    </div>
    {widgetSource !== 'ontario' && <div className="action-details__links">
      <a
        href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BCategory%253D%253DTransportation%255D%255BEligible+Applicants%253D%253DIndividual%255D/false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>
    </div>}
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('Price of gasoline:')}
          <InlineInput
            currency
            apiKey="input_takeaction_assumption_price_of_gasoline"
          />
          {t('per {{volumeUnit}}', { volumeUnit: isMetric ? t('L', { ns: 'units' }) : t('gal', { ns: 'units' }) })}
        </li>
        <li>
          {t('Keeping tires inflated improves fuel efficiency by')}
          <InlineInput
            percent
            maxLength={2}
            apiKey="input_takeaction_maintain_my_vehicles_tirespercent"
          />
        </li>
        <li>
          {t('Changing air filters regularly improves fuel efficiency by')}
          <InlineInput
            percent
            maxLength={2}
            apiKey="input_takeaction_maintain_my_vehicles_filterpercent"
          />
        </li>
        <li>
          {t('Keeping tires inflated costs')}
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_maintain_my_vehicles_tirescost"
          />
        </li>
        <li>
          {t('Changing air filters regularly costs')}
          <InlineInput
            currency
            maxLength={5}
            apiKey="input_takeaction_maintain_my_vehicles_filtercost"
          />
        </li>
      </ul>
    </div>
  </div>
);

MaintainMyVehicles.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  isMetric: PropTypes.bool.isRequired,
  widgetSource: PropTypes.string.isRequired,
  resultTakeactionMaintainMyVehiclesDispmiles: PropTypes.string.isRequired,
  resultTakeactionMaintainMyVehiclesMpg: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [
  'resultTakeactionMaintainMyVehiclesDispmiles',
  'resultTakeactionMaintainMyVehiclesMpg',
].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  isMetric: s.isMetric(state),
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = (_dispatch, _ownProps) => ({});

export default wrap(
  withT('maintainMyVehicles'),
  connect(mapStateToProps, mapDispatchToProps)(MaintainMyVehicles),
);
